






































































































































import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  nextTick,
  onUnmounted,
  reactive,
  ref,
  toRefs,
  watch,
} from '@vue/composition-api';
import { HelpCircleIcon, InfoCircleFilledIcon } from 'tdesign-icons-vue';
import { TdOptionProps } from 'tdesign-vue/es/select/type';
import { SubmitContext } from 'tdesign-vue';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';
import '@/renderer/assets/images/Icon/svg/successPay.svg';
import UserLogo from '@/renderer/components/user/components/UserLogo.vue';
import FileItem from '@/renderer/components/file/FileItem.vue';
import StatusTag from '@/renderer/components/SpacePage/components/StatusTag.vue';
import { CrumbItem } from '@/renderer/components/SpacePage/list.vue';
import CoLevelHelp, { helpHandler } from '@/renderer/components/dialog/AddTransfer/components/coLevelHelp.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import spaceATM from '@/renderer/scripts/utils/AccessTokenManager/space';
import { FileApplyCheckData, FileApplyParams } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import tips from '@/renderer/scripts/utils/tips';
import { isDisabledAllAuth } from '@/renderer/scripts/utils/tools';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { fileApplyHandler } from '@/renderer/components/dialog/FileApply/composition/fileApplyHandler';
import { SMH } from '@/renderer/scripts/libs/smh-sdk-class';
import smh from '@/renderer/scripts/smh';
interface IFormData {
  requestRoleId: number | '';
  requestReason: string;
}
/**
 * 权限申请弹窗
 */
export default defineComponent({
  name: 'FileApplyDialog',
  components: {
    UserLogo,
    StatusTag,
    FileItem,
    BaseIcon,
    InfoCircleFilledIcon,
    HelpCircleIcon,
    CoLevelHelp,
  },
  props: {
    // 申请文件对应的空间id
    spaceId: {
      type: String,
      default: '',
    },
    //  部门列表（xx部门/xx小组/xx文件夹）
    departmentList: {
      type: Array as () => Array<CrumbItem>,
      required: true,
      default: [],
    },
    selectedList: {
      type: Array as () => Array<SMH.SpaceFileItemData | SMH.FavoriteFileItemData | SMH.RecentlyUsedFileItemData>,
      required: true,
    },
    // 非必填，作为辅助处理
    currentApplyFile: {
      type: Object as () => SMH.SpaceFileItemData | SMH.FavoriteFileItemData | SMH.RecentlyUsedFileItemData,
      required: false,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const { spaceId, selectedList, departmentList, currentApplyFile } = toRefs(props);
    const confirm = ref(false); // 是否在二次确认环境
    // 提交的loading
    const loading = ref(false);
    // 弹窗加载的waiting(需要判断文件是否已经在审批中）
    const waiting = ref(false);
    // 组件状态（success：提交成功）
    const status = ref<'new' | 'pending' | 'success'>('new');
    const successInfo = reactive({
      requestPermission: '',
      requestId: '',
    });
    const formData: IFormData = reactive({
      requestReason: '',
      requestRoleId: '',
    });
    const formRules = {
      requestRoleId: [
        {
          required: true,
          message: i18n_t('请选择要申请的权限'),
          type: 'error',
          trigger: 'change',
        },
        {
          validator: (val: number) => val > 0,
          message: i18n_t('请选择要申请的权限'),
        },
      ],
      requestReason: [
        {
          validator: (val: string) => val?.length <= 120,
          message: i18n_t('您的内容不能大于120个字'),
        },
      ],
    };
    // 选中所有文件请求获得的角色列表信息
    const filesRoleList = ref<FileApplyCheckData[]>([]);
    // 统计全部都存在的角色id
    const unionRoleIds = ref<number[]>([]);
    const departmentListInner = computed<string[]>(_ => {
      if (departmentList.value.length) {
        return departmentList.value.map(item => item.content);
      }
      return [''];
    });
    // 部门列表转义字符串
    const departmentListString = computed<string>(_ => {
      if (departmentListInner.value.length > 1) {
        const directoryPath = departmentListInner.value.slice(1);
        return directoryPath.join('/');
      }
      return '/';
    });
    // 用户信息-真实名称
    const userName = computed(_ => vm.$store.getters.userBaseInfo.nickname);
    // 用户信息-脱敏手机号码
    const userPhoneNumber = computed(_ => vm.$store.getters.userBaseInfo.phoneNumber);
    // 用户信息-脱敏用户账号
    const userAccountName = computed(_ => vm.$store.getters.userBaseInfo.accountName);
    // 选择的文件的路径处理一遍
    const selectedPathArray = computed(() => selectedList.value.map(selected => selected.path.join('/')));
    // 角色列表
    const roleOptions = computed<TdOptionProps[]>(() => {
      const options: TdOptionProps[] = [];
      const { roles } = vm.$store.getters;
      roles
        .filter((role: SMH.Role) => {
          // 来自协作群组的文件需要过滤
          // 在协作群组路由下的文件需要过滤
          const collaborationRoute = ['collaborationSpace', 'collaborationSpaceList'].includes(vm.$route.name || '');
          const firstFile = selectedList.value[0];
          if (collaborationRoute || firstFile?.spaceTag === 'group' || currentApplyFile?.value?.spaceTag === 'group') {
            return !role.canAuthorize && !isDisabledAllAuth(role) && !role.isOwner;
          }
          return true;
        })
        .forEach((role: SMH.Role) => {
          const option = {
            label: role.name,
            value: role.id,
            disabled: false,
          };
          // 交集出现了对应id，则进行禁用
          const res = unionRoleIds.value.find((roleId: number) => roleId === role.id);
          if (res) {
            option.disabled = true;
            option.label += i18n_t('（当前权限）');
          }
          options.push(option);
        });
      return options;
    });
    const requestApplyMessage = computed(() => {
      return i18n_t('已申请{slot1}权限', {
        slot1: successInfo.requestPermission,
      });
    });
    const requestApplyResultMessage = computed(() => {
      return i18n_t('单号为{slot1}，请耐心等待审批。', {
        slot1: successInfo.requestId,
      });
    });
    const title = computed(() => {
      if (status.value === 'new') return i18n_t('权限审批申请');
      if (status.value === 'success') return i18n_t('申请成功');
      if (status.value === 'pending') return i18n_t('申请中');
      return i18n_t('申请失败');
    });
    // 文件路径
    const filePath = computed<string>(() => {
      const fileApplyDetail = filesRoleList.value[0];
      let res = [];
      if (fileApplyDetail?.spaceTag === 'group') {
        res.push(`${fileApplyDetail?.group?.name}`);
      }
      const firstFile = selectedList.value[0];
      res = res.concat(firstFile?.path || []).filter(v => v);
      if (res && res.length <= 1) {
        return '/';
      }
      return res.slice(0, res.length - 1).join('/');
    });
    const { show: showHelp, openHelp } = helpHandler();
    const { fileApplyMethods, spacePath } = fileApplyHandler();
    const methods = {
      isValid(index: number) {
        const currentFile = filesRoleList.value[index];
        return currentFile?.isValid;
      },
      hasApplied(index: number) {
        const currentFile = filesRoleList.value[index];
        return currentFile?.hasApplied;
      },
      helpClick() {
        openHelp();
      },
      reset() {
        loading.value = false;
        confirm.value = false;
        successInfo.requestId = '';
        successInfo.requestPermission = '';
        if (status.value === 'new') {
          const form = vm.$refs.form as any;
          form.reset();
        } else {
          formData.requestRoleId = '';
          formData.requestReason = '';
        }
        filesRoleList.value = [];
        unionRoleIds.value = [];
        status.value = 'new';
      },
      getRoleById(index: number) {
        const valueElement = filesRoleList.value[index];
        if (!valueElement) return '';
        if (valueElement.oldRoleIds?.length > 1) {
          return i18n_t('多种');
        }
        const roleName = vm.$store.getters.allRoles.find((role: SMH.Role) => role.id === valueElement.oldRoleIds[0]);
        return roleName?.name || '';
      },
      jumpToRoute: () => {
        methods.onCancel();
        nextTick(() => {
          dispatchRouter({
            name: 'fileApply',
            query: {
              tab: 'myApply',
            },
          });
        });
      },
      mySpaceId: async () => {
        return spaceId?.value || (await spaceATM.getPersonalSpaceIdAsync());
      },
      // 检查重复权限
      checkRepeatPermission: (requestRoleId: number) => {
        return filesRoleList.value.find((filesRole: FileApplyCheckData) => {
          const res: number | undefined = filesRole.oldRoleIds.find((roleId: number) => roleId === requestRoleId);
          return res;
        });
      },
      async onSubmit({ validateResult, firstError }: SubmitContext<IFormData>) {
        loading.value = true;
        try {
          if (validateResult === true && formData.requestRoleId !== '') {
            if (selectedPathArray.value?.length > 50) {
              tips.error(i18n_t('审批数量不能超过50个'));
              return;
            }
            const params: FileApplyParams = {
              spaceId: await methods.mySpaceId(),
              pathList: selectedPathArray.value,
              title: '',
              reason: formData.requestReason,
              roleId: formData.requestRoleId,
            };
            // 检查是否有重复申请的权限，若存在，则直接return
            if (confirm.value === false) {
              const repeatPermission = methods.checkRepeatPermission(formData.requestRoleId);
              if (repeatPermission) {
                confirm.value = true;
                return;
              }
            }
            const { data } = await smh.userAPI.addFileApply(params);
            //  若失败的数量和文件数量一致，则认为提交失败
            if (data.failedItems.length === params.pathList.length) {
              tips.success(i18n_t('提交失败，请检查文件状态'));
            } else {
              tips.success(i18n_t('提交成功'));
              status.value = 'success';
              const tdOptionProps = roleOptions.value.find((value: TdOptionProps) => value.value === params.roleId);
              if (tdOptionProps?.label) successInfo.requestPermission = tdOptionProps.label;
              successInfo.requestId = data.applyNo;
            }
          } else {
            tips.error(`${firstError}`);
          }
        } catch (e) {
          confirm.value = false;
          tips.error(e as MsgError);
        } finally {
          loading.value = false;
        }
      },
      // 计算所有文件的超集（用来做options选项的过滤，如存在了则禁止）
      // const superSetRoles = computed(() => {});
      // 计算所有文件的并集（用来做options选项的过滤）
      // 例如：选中的所有文件都存在了[观察者],则禁用观察者选项
      calcUnionSetRoles: (filesRoleList: FileApplyCheckData[]) => {
        const unionRoleIds: number[] = [];
        const tempMap = new Map<number, number>();
        filesRoleList.forEach((filesRoleIds: FileApplyCheckData) => {
          filesRoleIds.oldRoleIds.forEach((roleId: number) => {
            const number = tempMap.get(roleId);
            if (number && number > 0) {
              tempMap.set(roleId, 1 + number);
            }
            // 最后做一个兜底初始化
            if (!number) {
              tempMap.set(roleId, 1);
            }
          });
        });
        tempMap.forEach((size: number, roleId: number) => {
          if (size === filesRoleList.length) {
            unionRoleIds.push(roleId);
          }
        });
        return unionRoleIds;
      },
      async initData() {
        waiting.value = true;
        formData.requestReason = i18n_t('你好，我是{slot1}，辛苦帮忙开通权限。', {
          slot1: userName.value,
        });
        const params = {
          spaceId: await methods.mySpaceId(),
          pathList: selectedPathArray.value,
        };
        try {
          const { data } = await smh.userAPI.checkFileApply(params);
          // 发现当前文件是审批通过的，就直接进入success结果页（多选不支持）
          const datum = data[0];
          if (params.pathList.length === 1 && datum.hasApplied) {
            status.value = 'pending';
            [successInfo.requestId] = datum.applyNoList;
          }
          filesRoleList.value = data;
          // 文件路径 文件空间位置(以第一个为准即可）
          fileApplyMethods.analyseLocationInfo(filesRoleList.value[0]);
        } catch (e: MsgError) {
          tips.error(e);
        } finally {
          waiting.value = false;
        }
        unionRoleIds.value = methods.calcUnionSetRoles(filesRoleList.value); // 统计全部都存在的roleId
      },

      onCancel() {
        innerShow.value = false;
        loading.value = false;
      },
      cancelConfirm() {
        confirm.value = false;
      },
      onConfirm() {
        const formRef = vm.$refs?.form as any;
        formRef.submit();
      },
    };
    const innerShow = computed({
      get() {
        return props.visible;
      },
      set(val) {
        context.emit('update:visible', val);
      },
    });
    watch(
      () => props.visible,
      val => {
        if (val) {
          methods.initData();
        } else {
          methods.reset();
        }
      },
    );
    return {
      filePath,
      spacePath,
      filesRoleList,
      showHelp,
      confirm,
      waiting,
      departmentListInner,
      selectedPathArray,
      departmentListString,
      userName,
      userPhoneNumber,
      userAccountName,
      innerShow,
      title,
      roleOptions,
      formData,
      formRules,
      status,
      requestApplyMessage,
      requestApplyResultMessage,
      loading,
      methods,
    };
  },
});
